package com.tovtalk.ui.components

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import com.tovtalk.ui.theme.LocalTovTalkHebrewFontFamily
import com.tovtalk.ui.theme.LocalTovTalkTypography

/** Hebrew Unicode block (letters, points, etc.). */
private fun String.containsHebrew(): Boolean = any { it in '\u0590'..'\u05FF' }

/**
 * Text that uses [LocalTovTalkHebrewFontFamily] when the string contains Hebrew;
 * otherwise uses the given [style] (system/default font).
 * Use this for user-facing strings that may be in Hebrew or English.
 */
@Composable
fun TovTalkText(
    text: String,
    modifier: Modifier = Modifier,
    style: TextStyle = LocalTovTalkTypography.current.bodyMedium,
    color: Color = Color.Unspecified,
    textAlign: TextAlign? = null,
    overflow: TextOverflow = TextOverflow.Clip,
    maxLines: Int = Int.MAX_VALUE,
) {
    val hebrewFont = LocalTovTalkHebrewFontFamily.current
    val effectiveStyle = if (text.containsHebrew() && hebrewFont != null) {
        style.copy(fontFamily = hebrewFont)
    } else {
        style
    }
    Text(
        text = text,
        modifier = modifier,
        style = effectiveStyle,
        color = color,
        textAlign = textAlign,
        overflow = overflow,
        maxLines = maxLines,
    )
}
